// KPI — Pagamenti e crediti (4) dallo scadenziario, con scelta periodo / storico
import React, { useState } from "react";
import { Banknote } from "lucide-react";
import { useFm, fmtInt, fmtDate, Seg } from "../bi/biShared";
import { Kpi, Group, KpiGrid, fmtPct, fmtDays } from "./kpiShared";

const SCOPES = [{ value: "period", label: "Documenti del periodo" }, { value: "all", label: "Tutto lo storico" }];

export default function KpiFinance({ data }) {
  const fm = useFm();
  const F = data.formulas;
  const [scope, setScope] = useState("period");
  const f = data.finance;
  const v = scope === "period" ? f.period : f.all;
  const d = (k) => (scope === "period" ? f.delta_pct[k] : undefined);
  return (
    <div className="space-y-4" data-testid="kpi-tab-finance">
      <Group num={4} title="Pagamenti e crediti" icon={Banknote} note={data.notes.finance} testId="kpi-g4">
        <div className="flex items-center justify-between gap-2 flex-wrap">
          <Seg options={SCOPES} value={scope} onChange={setScope} testIdPrefix="kpi-fin-scope" size="sm" />
          <p className="text-xs text-stone-500" data-testid="kpi-fin-docs">{fmtInt(v.docs)} documenti fiscali{f.excluded_docs ? ` · ${fmtInt(f.excluded_docs)} di clienti esclusi` : ""}</p>
        </div>
        <KpiGrid>
          <Kpi label="Importo dovuto" value={fm(v.due_total)} delta={d("due_total")} formula={F.due} testId="kpi-fin-due" />
          <Kpi label="Incassato" value={fm(v.collected)} delta={d("collected")} formula={F.collected} testId="kpi-fin-collected" accent />
          <Kpi label="Da incassare" value={fm(v.open)} delta={d("open")} invert formula={F.open} testId="kpi-fin-open" />
          <Kpi label="Tasso di incasso" value={fmtPct(v.collection_rate_pct)} delta={d("collection_rate_pct")} formula={F.coll_rate} testId="kpi-fin-rate" />
          <Kpi label="Giorni medi di incasso" value={fmtDays(v.avg_days_to_pay)} delta={d("avg_days_to_pay")} invert formula={F.dso} testId="kpi-fin-dso" />
          <Kpi label="Ritardo medio di pagamento" value={fmtDays(v.avg_delay_days)} delta={d("avg_delay_days")} invert formula={F.delay} testId="kpi-fin-delay" />
          <Kpi label="Tasso di pagamento puntuale" value={fmtPct(v.punctual_rate_pct)} delta={d("punctual_rate_pct")} sub={`${fmtInt(v.punctual_docs)} puntuali · ${fmtInt(v.late_docs)} in ritardo · su ${fmtInt(v.eligible_docs)}`} formula={F.punctual} testId="kpi-fin-punctual" />
          <Kpi label="Tasso di insoluto / scaduto" value={fmtPct(v.overdue_rate_pct)} delta={d("overdue_rate_pct")} invert sub={`${fm(v.overdue_unpaid)} scaduti non pagati`} formula={F.overdue} testId="kpi-fin-overdue" />
        </KpiGrid>
        <p className="text-[11px] text-stone-500" data-testid="kpi-fin-footnote">
          Scadenze valutate al {fmtDate(f.today)}. {scope === "period" ? `Documenti con data documento nel periodo ${fmtDate(data.period.from)} – ${fmtDate(data.period.to)}; confronto con ${fmtDate(data.period.prev_from)} – ${fmtDate(data.period.prev_to)}.` : "Tutti i documenti fiscali presenti nello scadenziario."}
        </p>
      </Group>
    </div>
  );
}
